<svelte:options runes={true} />

<script lang="ts">
  import type { SortOption } from "~/lib/bloomreach/types";
  import type { Filter, FilterState } from "~/lib/filters/types";
  import type { ProductCardProps } from "~/components/product/ProductCard/types";
  import FilterBar from "~/components/filters/FilterBar/FilterBar.svelte";
  import ProductCardGrid from "~/components/collection/ProductCardGrid/ProductCardGrid.svelte";
  import LoadMore from "~/components/ui/LoadMore/LoadMore.svelte";

  interface Props {
    filters: Filter[];
    sortOptions: SortOption[];
    products: ProductCardProps[];
    loading?: boolean;
    skeletonCount?: number;
    error?: boolean;
    resultCount?: number;
    sort?: string;
    hasMore?: boolean;
    loadingMore?: boolean;
    loadMoreError?: boolean;
    activeFilters?: FilterState;
    onFiltersChange?: (values: FilterState) => void;
    onSortChange?: (value: string) => void;
    onReset?: () => void;
    onLoadMore?: () => void;
    class?: string;
  }

  let {
    filters,
    sortOptions,
    products,
    loading = false,
    skeletonCount,
    error = false,
    resultCount,
    sort = "",
    hasMore = false,
    loadingMore = false,
    loadMoreError = false,
    activeFilters = $bindable({}),
    onFiltersChange,
    onSortChange,
    onReset,
    onLoadMore,
    class: className = "",
  }: Props = $props();

  function handleFilterChange(values: FilterState) {
    activeFilters = values;
    onFiltersChange?.(values);
  }
</script>

<div class={["da-product-list-layout", className]}>
  <FilterBar
    {filters}
    {sortOptions}
    bind:activeFilters
    onChange={handleFilterChange}
    {onReset}
    {loading}
    {error}
    {resultCount}
    {sort}
    {onSortChange}
  />

  <ProductCardGrid {products} {loading} {error} {skeletonCount} />

  {#if hasMore || loadMoreError}
    <div class="da-product-list-layout__load-more">
      <LoadMore loading={loadingMore} error={loadMoreError} onClick={onLoadMore} />
    </div>
  {/if}
</div>

<style>
  @layer aurora {
    .da-product-list-layout {
      display: flex;
      flex-direction: column;
      min-height: 600px;
      container-type: inline-size;
    }

    .da-product-list-layout__load-more {
      padding: var(--da-space-8) var(--da-space-4);
      display: flex;
      justify-content: center;
    }
  }
</style>
